import { Alert, Button, Card, CardHeader, CardBody } from '@heroui/react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@/redux/hooks';

export function SurveyRecord({ editable, handleRedo, lastEntryDate }) {
  const { t } = useTranslation('survey');
  const navigate = useNavigate();

  const { demo } = useAppSelector(({ auth }) => auth);

  const date = dayjs(lastEntryDate).format('LLLL');
  const redoBtn = demo || editable;

  if (redoBtn) {
    return (
      <div className="flex flex-col items-center justify-center h-[100dvh]">
        <div className="sm:max-w-xl w-full">
          <Card shadow="sm" className="border border-grey px-4">
            <CardHeader>
              <h1 className="text-xl font-semibold">
                {t('surveyrecord.title')}
              </h1>
            </CardHeader>
            <CardBody className="gap-4">
              <p>{t('surveyrecord.description_date', { date })}</p>
              <p>{t('surveyrecord.description')}</p>
              <Alert color="primary" variant="flat">
                {t('surveyrecord.description_tip')}
              </Alert>
              <div className="flex justify-center items-center gap-4">
                <Button className="w-1/2" color="primary" onPress={handleRedo}>
                  {t('surveyrecord.action_review')}
                </Button>
                <Button
                  className="w-1/2"
                  color="primary"
                  onPress={() => navigate('/')}
                  variant="bordered"
                >
                  {t('surveyrecord.action_later')}
                </Button>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-[100dvh]">
      <div className="sm:max-w-xl w-full">
        <Card shadow="sm" className="border border-grey px-4">
          <CardHeader>
            <h1 className="text-xl font-semibold">
              {t('surveyrecord.title_completed', { date })}
            </h1>
          </CardHeader>
          <CardBody className="gap-4">
            <p>{t('surveyrecord.description_exit')}</p>
            <div className="flex justify-center items-center gap-4">
              <Button
                className="w-1/2"
                color="primary"
                onPress={() => navigate('/')}
              >
                {t('common.action.exit_session')}
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
